import { AdminMixer } from '@linktivity/sagano';

import config from '../config';

const adminMixer = new AdminMixer.AdminMixerApi(config);

export default adminMixer;
